// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor2 from '@/game/prefabs/World/Mentors/Mentor2';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from '@/game/scenes/TilemapScenes/TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level27 extends TilemapScene {
  constructor() {
    super('Level27');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // spring_biome_6
    const spring_biome_6 = this.add.tilemap('spring-biome-6');
    spring_biome_6.addTilesetImage('spring 32x32', 'spring 32x32');
    spring_biome_6.addTilesetImage('spring 48x32', 'spring 48x32');
    spring_biome_6.addTilesetImage(
      'spring forest wang tiles',
      'spring forest wang tiles',
    );
    spring_biome_6.addTilesetImage('spring forest', 'spring forest');
    spring_biome_6.addTilesetImage(
      'spring trees 80x112',
      'spring trees 80x112',
    );
    spring_biome_6.addTilesetImage(
      'spring water sparkles B',
      'spring water sparkles B',
    );
    spring_biome_6.addTilesetImage('spring waterfall B', 'spring waterfall B');
    spring_biome_6.addTilesetImage('spring 16x32', 'spring 16x32');
    spring_biome_6.addTilesetImage('bonus bridge', 'bonus bridge');

    // tilemapLayers
    const tilemapLayers = this.add.container(0, 0);

    // wang_Terrain_1
    const wang_Terrain_1 = spring_biome_6.createLayer(
      'Wang Terrain',
      ['spring forest wang tiles'],
      0,
      0,
    )!;
    tilemapLayers.add(wang_Terrain_1);

    // water_Sparkles_1
    const water_Sparkles_1 = spring_biome_6.createLayer(
      'Water Sparkles',
      ['spring water sparkles B'],
      0,
      0,
    )!;
    tilemapLayers.add(water_Sparkles_1);

    // cliff___Spring_Forest_1
    const cliff___Spring_Forest_1 = spring_biome_6.createLayer(
      'Cliff - Spring Forest',
      ['spring forest'],
      0,
      0,
    )!;
    tilemapLayers.add(cliff___Spring_Forest_1);

    // bridge
    const bridge = spring_biome_6.createLayer(
      'Bridge',
      ['bonus bridge'],
      0,
      0,
    )!;
    tilemapLayers.add(bridge);

    // waterfall_1
    const waterfall_1 = spring_biome_6.createLayer(
      'Waterfall',
      ['spring waterfall B'],
      0,
      0,
    )!;
    tilemapLayers.add(waterfall_1);

    // waterfall_Effects_1
    const waterfall_Effects_1 = spring_biome_6.createLayer(
      'Waterfall Effects',
      ['spring waterfall B'],
      0,
      0,
    )!;
    tilemapLayers.add(waterfall_Effects_1);

    // water_Props_1
    const water_Props_1 = spring_biome_6.createLayer(
      'Water Props',
      ['spring forest'],
      0,
      0,
    )!;
    tilemapLayers.add(water_Props_1);

    // portal
    const portal = new Portal(this, 463, 611);
    this.add.existing(portal);

    // player
    const player = new Player(this, 400, 36);
    this.add.existing(player);

    // mentor
    const mentor = new Mentor2(this, 368, 90);
    this.add.existing(mentor);

    // worldNode
    const worldNode = new WorldNode(this, 296, 164);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 216, 60);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 64, 284);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 72, 388);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 640, 376);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 668, 420);
    this.add.existing(worldNode_5);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 284, 380);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 548, 64);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 616, 584);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 416, 464);
    this.add.existing(worldNode_9);

    // springTree_31
    const springTree_31 = new ForestTree1(
      this,
      -4,
      232,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_31);

    // springTree_2
    const springTree_2 = new ForestTree1(
      this,
      -28,
      272,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_2);

    // springTree_27
    const springTree_27 = new ForestTree1(
      this,
      12,
      276,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_27);

    // springTree_30
    const springTree_30 = new ForestTree1(
      this,
      -10,
      317,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_30);

    // springTree_1
    const springTree_1 = new ForestTree1(
      this,
      10,
      351,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_1);

    // springTree_26
    const springTree_26 = new ForestTree1(
      this,
      -4,
      412,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_26);

    // springTree_29
    const springTree_29 = new ForestTree1(
      this,
      12,
      432,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_29);

    // springTree1
    const springTree1 = new ForestTree1(
      this,
      43,
      509,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree1);

    // springTree
    const springTree = new ForestTree1(this, -1, 459, 'spring trees 80x112', 1);
    this.add.existing(springTree);

    // springTree_3
    const springTree_3 = new ForestTree1(
      this,
      291,
      695,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_3);

    // springTree_5
    const springTree_5 = new ForestTree1(
      this,
      604,
      484,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_5);

    // springTree_14
    const springTree_14 = new ForestTree1(
      this,
      612,
      500,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(springTree_14);

    // springTree_7
    const springTree_7 = new ForestTree1(
      this,
      644,
      528,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_7);

    // springTree_4
    const springTree_4 = new ForestTree1(
      this,
      670,
      563,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_4);

    // springTree_8
    const springTree_8 = new ForestTree1(
      this,
      716,
      583,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_8);

    // springTree_25
    const springTree_25 = new ForestTree1(
      this,
      712,
      640,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_25);

    // springTree_6
    const springTree_6 = new ForestTree1(
      this,
      701,
      335,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_6);

    // springTree_11
    const springTree_11 = new ForestTree1(
      this,
      688,
      660,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_11);

    // springTree_9
    const springTree_9 = new ForestTree1(
      this,
      675,
      703,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_9);

    // springTree_10
    const springTree_10 = new ForestTree1(
      this,
      572,
      696,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_10);

    // springTree_12
    const springTree_12 = new ForestTree1(
      this,
      624,
      700,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_12);

    // springTree_13
    const springTree_13 = new ForestTree1(
      this,
      375,
      567,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_13);

    // springTree_15
    const springTree_15 = new ForestTree1(
      this,
      -1,
      617,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_15);

    // springTree_18
    const springTree_18 = new ForestTree1(
      this,
      626,
      352,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_18);

    // springTree_16
    const springTree_16 = new ForestTree1(
      this,
      135,
      434,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_16);

    // springTree_17
    const springTree_17 = new ForestTree1(
      this,
      603,
      374,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_17);

    // springTree_19
    const springTree_19 = new ForestTree1(
      this,
      524,
      241,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_19);

    // springTree_21
    const springTree_21 = new ForestTree1(
      this,
      683,
      168,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_21);

    // springTree_22
    const springTree_22 = new ForestTree1(
      this,
      511,
      30,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_22);

    // springTree_23
    const springTree_23 = new ForestTree1(
      this,
      207,
      14,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_23);

    // springTree_24
    const springTree_24 = new ForestTree1(
      this,
      40,
      95,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_24);

    // springTree_28
    const springTree_28 = new ForestTree1(
      this,
      -6,
      516,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_28);

    // springTree_32
    const springTree_32 = new ForestTree1(
      this,
      136,
      297,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_32);

    // springTree_33
    const springTree_33 = new ForestTree1(
      this,
      67,
      240,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_33);

    // springTree_34
    const springTree_34 = new ForestTree1(
      this,
      195,
      737,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_34);

    // springTree_35
    const springTree_35 = new ForestTree1(
      this,
      -14,
      726,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_35);

    // springTree_36
    const springTree_36 = new ForestTree1(
      this,
      418,
      453,
      'spring trees 80x112',
      0,
    );
    this.add.existing(springTree_36);

    // springTree_37
    const springTree_37 = new ForestTree1(
      this,
      422,
      285,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_37);

    // springTree_38
    const springTree_38 = new ForestTree1(
      this,
      369,
      193,
      'spring trees 80x112',
      1,
    );
    this.add.existing(springTree_38);

    // springTree_20
    const springTree_20 = new ForestTree1(
      this,
      268,
      280,
      'spring trees 80x112',
      2,
    );
    this.add.existing(springTree_20);

    // springTree_39
    const springTree_39 = new ForestTree1(this, 328, 580, 'spring 32x', 0);
    this.add.existing(springTree_39);

    // springTree_40
    const springTree_40 = new ForestTree1(this, 256, 404, 'spring 32x', 1);
    this.add.existing(springTree_40);

    // springTree_41
    const springTree_41 = new ForestTree1(this, 120, 188, 'spring 32x', 1);
    this.add.existing(springTree_41);

    // springTree_42
    const springTree_42 = new ForestTree1(this, 80, 100, 'spring 32x', 1);
    this.add.existing(springTree_42);

    // springTree_43
    const springTree_43 = new ForestTree1(this, 268, 156, 'spring 32x', 0);
    this.add.existing(springTree_43);

    // springTree_44
    const springTree_44 = new ForestTree1(this, 304, 80, 'spring 32x', 0);
    this.add.existing(springTree_44);

    // springTree_45
    const springTree_45 = new ForestTree1(this, 576, 156, 'spring 32x', 0);
    this.add.existing(springTree_45);

    // springTree_46
    const springTree_46 = new ForestTree1(this, 556, 264, 'spring 32x', 1);
    this.add.existing(springTree_46);

    // springTree_47
    const springTree_47 = new ForestTree1(this, 668, 344, 'spring 32x', 1);
    this.add.existing(springTree_47);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 26;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 26;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 26;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 26;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 26;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 26;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 26;
    worldNode_6.NPCId = 6;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 26;
    worldNode_7.NPCId = 7;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 26;
    worldNode_8.NPCId = 8;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 26;
    worldNode_9.NPCId = 9;

    this.portal = portal;
    this.player = player;
    this.mentor = mentor;
    this.worldNode = worldNode;
    this.worldNode_1 = worldNode_1;
    this.worldNode_2 = worldNode_2;
    this.worldNode_3 = worldNode_3;
    this.worldNode_4 = worldNode_4;
    this.worldNode_5 = worldNode_5;
    this.worldNode_6 = worldNode_6;
    this.worldNode_7 = worldNode_7;
    this.worldNode_8 = worldNode_8;
    this.worldNode_9 = worldNode_9;
    this.spring_biome_6 = spring_biome_6;

    this.events.emit('scene-awake');
  }

  private portal!: Portal;
  private player!: Player;
  private mentor!: Mentor2;
  private worldNode!: WorldNode;
  private worldNode_1!: WorldNode;
  private worldNode_2!: WorldNode;
  private worldNode_3!: WorldNode;
  private worldNode_4!: WorldNode;
  private worldNode_5!: WorldNode;
  private worldNode_6!: WorldNode;
  private worldNode_7!: WorldNode;
  private worldNode_8!: WorldNode;
  private worldNode_9!: WorldNode;
  private spring_biome_6!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.spring_biome_6,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
